import { inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { normalizeOperator } from '../../../common/functions';
import { InsectaServiceBase } from '../insecta.base.service';
import { ISearchRequest, ISearchResult } from '../insecta.models';

import { MessageService } from 'primeng/api';
import { downloadXlsxDocument } from '../../../common/functions';
import { notifyAndTrackError } from '../../../common/error';
import { AppInsightsService } from '../../app-insights.service';

@Injectable({
  providedIn: `root`
})
export class InsectaryDashboardService extends InsectaServiceBase {
  private readonly appInsights = inject(AppInsightsService);
  private readonly msgService = inject(MessageService);

  public getApprovalCount(request: ISearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    return this.post<ISearchResult>(`/dashboard/insectary/approval/count`, `v1`, request);
  }
  public getApprovalTable(request: ISearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    return this.post<ISearchResult>(`/dashboard/insectary/approval/table`, `v1`, request);
  }

  public async getInsectPrepExport(request: ISearchRequest): Promise<void> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    await firstValueFrom(this.fetchBlob(`/dashboard/insectary/insect/export`, `v1`, request))
      .then((response) => {
        const filename = `InsectPrepInstances-${new Date().toISOString().slice(0, 10)}.xlsx`;
        downloadXlsxDocument(response, filename);
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'ExportService', action: 'GetInstancesXlsx' });
      });
  }
  public getInsectPrepTable(request: ISearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    return this.post<ISearchResult>(`/dashboard/insectary/insect/table`, `v1`, request);
  }

  public async getSubstratePrepExport(request: ISearchRequest): Promise<void> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    await firstValueFrom(this.fetchBlob(`/dashboard/insectary/substrate/export`, `v1`, request))
      .then((response) => {
        const filename = `SubstratePrepInstances-${new Date().toISOString().slice(0, 10)}.xlsx`;
        downloadXlsxDocument(response, filename);
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'ExportService', action: 'GetInstancesXlsx' });
      });
  }
  public getSubstratePrepTable(request: ISearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    return this.post<ISearchResult>(`/dashboard/insectary/substrate/table`, `v1`, request);
  }

  public getCalendar(request: ISearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    return this.post<ISearchResult>(`/dashboard/insectary/calendar`, `v1`, request);
  }
  public getTable(request: ISearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    return this.post<ISearchResult>(`/dashboard/insectary/table`, `v1`, request);
  }

  public async getVendorExport(request: ISearchRequest): Promise<void> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    await firstValueFrom(this.fetchBlob(`/dashboard/insectary/vendor/export`, `v1`, request))
      .then((response) => {
        const filename = `VendorOrderExport-${new Date().toISOString().slice(0, 10)}.xlsx`;
        downloadXlsxDocument(response, filename);
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'ExportService', action: 'GetInstancesXlsx' });
      });
  }
  public getVendorTable(request: ISearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    return this.post<ISearchResult>(`/dashboard/insectary/vendor/table`, `v1`, request);
  }
}
